export const PeopleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2795 9.03652C16.5353 9.88902 17.4153 11.044 17.4153 12.584V15.334H21.082V12.584C21.082 10.5857 17.8095 9.40319 15.2795 9.03652Z"
        fill="currentColor"
      />
      <path
        d="M13.7486 8.00069C15.7745 8.00069 17.4153 6.35986 17.4153 4.33402C17.4153 2.30819 15.7745 0.667358 13.7486 0.667358C13.3178 0.667358 12.9145 0.759025 12.5295 0.887358C13.2903 1.83152 13.7486 3.03236 13.7486 4.33402C13.7486 5.63569 13.2903 6.83652 12.5295 7.78069C12.9145 7.90903 13.3178 8.00069 13.7486 8.00069Z"
        fill="currentColor"
      />
      <path
        d="M8.24862 8.00069C10.2745 8.00069 11.9153 6.35986 11.9153 4.33402C11.9153 2.30819 10.2745 0.667358 8.24862 0.667358C6.22278 0.667358 4.58195 2.30819 4.58195 4.33402C4.58195 6.35986 6.22278 8.00069 8.24862 8.00069ZM8.24862 2.50069C9.25695 2.50069 10.082 3.32569 10.082 4.33402C10.082 5.34236 9.25695 6.16736 8.24862 6.16736C7.24028 6.16736 6.41528 5.34236 6.41528 4.33402C6.41528 3.32569 7.24028 2.50069 8.24862 2.50069Z"
        fill="currentColor"
      />
      <path
        d="M8.24862 8.91736C5.80112 8.91736 0.915283 10.1457 0.915283 12.584V15.334H15.582V12.584C15.582 10.1457 10.6961 8.91736 8.24862 8.91736ZM13.7486 13.5007H2.74862V12.5932C2.93195 11.9332 5.77362 10.7507 8.24862 10.7507C10.7236 10.7507 13.5653 11.9332 13.7486 12.584V13.5007Z"
        fill="currentColor"
      />
    </svg>
  );
};
